export default {
  labels: {
    iwtk: "IWTK",
    i_want_the_kit: "I WANT THE KIT",
    // Common labels
    add: "Add",
    new: "New",
    edit: "Edit",
    delete: "Delete",
    restore: "Restore",
    permanent_delete: "Permanent Delete",
    name: "Name",
    description: "Description",
    search: "Search",
    show_hide: "Show/Hide",
    action: "Action",
    show: "Show",
    show_deleted: "Show Deleted",
    save: "Save",
    apply: "Apply",
    close: "Close",
    filter: "Filter",
    clear_filter: "Clear Filter",
    no_data_found: "No Data Found",
    clear: "Clear",
    back: "Back",
    enter: "Enter",
    of_your:"of your",
    // splash screen
    already_a_user: "Already a user?",
    new_user: "New user",
    // eligibility check
    birth_date: "Birth Date",
    select_birth_date: "Select Birth Date",
    zip_code: "Zip Code",
    county: "County",
    check_eligibility: "Check eligibility",
    go_back: "Go back",
    month: "Month",
    day: "Day",
    year: "Year",
    enter_program_code: "Enter Program Code",
    validate_program_code: "Validate Program Code",
    // login page
    username: "Username",
    email: "Email",
    password: "Password",
    login: "Login",
    forgot_password: "Forgot Password",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    register: "Register",
    username_email: "Username / Email",
    username_email_mobile: "Username (Email or Mobile Number)",
    return_to_website: "Return to website",
    // register
    first_name: "First Name",
    last_name: "Last Name",
    confirm_password: "Confirm Password",
    back_to_login: "Back to Login",
    back_to_eligibility_check: "Back to Eligibility Check",
    phone: "Phone Number",
    confirm_phone: "Confirm Phone Number",
    physical:"Physical",
    address_line_1: "Address Line 1",
    address_line_2: "Address Line 2",
    gender: "Gender",
    ethnicity: "Ethnicity",
    are_you_hispanic: "Are you hispanic?",
    sms: "SMS",
    mailing_address:"Mailing Address",
    mailing_address1: "Mailing Address Line 1",
    mailing_address2: "Mailing Address Line 2",
    mailing_city: "Mailing City",
    mailing_state: "Mailing State",
    mailing_zipcode: "Mailing Zip Code",
    mailing_county: "Mailing County",
    sex_assgined_at_birth:"Sex assigned at birth",
    who_do_you_have_sex_with:"Who do you have sex with?",
    text_message: "Text Message",
    // forgot password
    get_token: "Get Token",
    already_have_a_token: "Already have a token?",
    // reset password
    reset_password: "Reset Password",
    token: "Token",
    new_password: "New Password",
    back_to_forgotpassword: "Back to Forgot Password",
    // verification
    verification: "Verification",
    verify: "Verify",
    code: "Code",
    resend_verification_code: "Resend",
    didn_t_get_code: "Didn't get code?",
    // Risk Quiz
    risk_quiz: "Sexual Health Quiz",
    get_results: "Get Results",
    quiz_results: "Results",
    quiz_score: "Your score is ",
    click_for_signup: "Click here to place order",
    sign_up: "Sign Up",
    already_member: "Already a member?",
    // Place Order
    place_order: "Place Order",
    Order: "Order",
    iwtk_privacy_policy: "IWTK Privacy Policy",
    john_hopkins_privacy_policy: "Johns Hopkins Notice of Privacy Practices",
    //Profile email and password change
    pop_up_new_email: "New email",
    pop_up_new_phone: "New phone",
    pop_up_confirm_email: "Confirm email",
    pop_up_confirm_phone: "Confirm phone",
    // navbar
    help: "Help",
    profile: "Profile",
    logout: "Logout",
    hello: "Hello",
    you_are: "You are",
    toggle_nav: "Toggle navigation",
    select_tests: "Select Tests",
    // Secondary Navbar Items
    Profile: "Profile",
    Orders: "Orders",
    Results: "Results",
    MessageCenter: "Message Center",
    //Risk status labels
    LowRisk: "Not very likely you were exposed to an STI",
    IntermediateRisk: "Somewhat likely you were exposed to an STI",
    HighRisk: "Likely you were exposed to an STI",
    VeryHighRisk: "Very likely you were exposed to an STI",
    points: "points",
    // Dashboard
    dashboard: "Dashboard",
    more_info: "More Info",
    view_orders: "View Orders",
    orders_by_state: "Orders by State",
    last_days: "Last Days",
    state_name: "State Name",
    order_count: "Order Count",
    positive_test_table: "Positive Tests",
    positive_count: "Positive Count",
    total_tests: "Total Tests",
    disease_name: "Disease Name",
    // Master setting
    settings: "Settings",
    masters: "Masters",
    users: "Users",
    participants: "Participants",
    orders: "Orders",
    testing: "Testing",
    // Master race
    races: "Races",
    race: "Race",
    // Master Gender Identity
    gender_identity: "Gender Identity",
    gender_identities: "Gender Identities",
    // Master sex with
    sex_with: "Sex With",
    sex_withs: "Sex Withs",
    who_sex_with: "Who do you have sex with?",
    // Master sex at birth
    sex_at_birth: "Sex at Birth",
    sex_at_births: "Sex at Births",
    // Master Disease
    disease: "Disease",
    diseases: "Diseases",
    // Master How-Heard
    how_heard: "How Heard",
    other_how_heard: "How Heard Other",
    select_how_heard: "How did you hear about IWTK?",
    phone_number_positive_result: "What phone number should we call to inform you of a positive result?",
    // Master Specimen type
    specimen_type: "Specimen Type",
    specimen_types: "Specimen Types",
    // Master Clinic
    clinic: "Clinic",
    clinics: "Clinics",
    address: "Address",
    state: "State",
    cost: "Cost",
    other_information: "Other Information",
    spanish:"Spanish",
    address1: "Address 1",
    address2: "Address 2",
    phone1: "Phone Number 1",
    ext1: "Ext 1",
    phone2: "Phone Number 2",
    ext2: "Ext 2",
    url: "URL",
    city: "City",
    clinic_name: "Clinic Name",
    confirm_program_code_and_address: "Confirm Program Code and Physical (Home) Address",
    zipcode: "Zip Code",
    // Master Assay Type
    assay_type: "Assay Type",
    assay_types: "Assay Types",
    // Master Symptom
    symptom: "Symptom",
    symptoms: "Symptoms",
    // Master Sample Type
    sample_type: "Sample Type",
    //Account
    account: "Account",
    permission: "Permission",
    role: "Role",
    //Permission
    status: "Status",
    permission_name: "Permission Name",
    //Module
    module_name: "Module Name",
    all: "All",
    view: "View",
    modify: "Modify",
    //Role
    role_name: "Role Name",
    //User
    user: "User",
    confirm_email: "Confirm Email",
    //Test Type
    min_17_years: "Minimum 17 years Required",
    once_in_3_months: "Required Once In 3 Months",
    genital_test: "Genital Test",
    //Test Kit
    test_kit: "Test Kit",
    test_kits: "Test Kits",
    select_test_type: "Select Test Type",
    select: "Select",
    // Order
    order_date: "Order Date",
    order_start_date: "Order Date Start",
    order_end_date: "Order Date End",
    completed_date_start: "Completed Date Start",
    completed_date_end: "Complated Date End",
    order_number: "Order Number",
    order_history: "Order History",
    results: "Results",
    lab_results: "Lab Results",
    lab_name: "Lab Name",
    external_order_number: "External Order Number",
    screen_reference: "Screen Reference",
    test_time: "Test Time",
    rack_tube: "Rack Tube",
    rlu: "RLU",
    tests: "Tests",
    add_result: "Add Result",
    result: "Result",
    //report of order specimen symptoms
    master_order_symptoms: "Order Specimen Symptoms",
    date_of_birth: "Date of birth",
    // Participant
    is_first_order_completed: "Is first order completed?",
    participant_information: "Participant Information",
    age: "Age",
    preferred_contact_method: "Preferred Contact",
    language_preference: "Language Preference",
    hispanic: "Hispanic",
    not_hispanic: "Not Hispanic",
    shipping_address: "Mailing Address",
    home:"Home",
    home_address:"Physical (Home) Address",
    physical_or_mailing_address:"Is Physical (Home) Address the same as Mailing Address?",
    show_map: "Show Map",
    yet_to_verified: "is yet to be verified",
    // change password
    current_password: "Current password",
    change_password: "Change Password",
    // messages
    title: "Title",
    date: "Date",
    message: "Message",
    type: "Type",
    all_read: "Mark all as read",
    send: "Send",
    loading: "Loading...",
    mark_as_unread: "Mark as unread",
    mark_as_read: "Mark as read",
    select_one: "Select one",
    // Admin
    roles: "Roles",
    // Order view
    review: "Review",
    fill_ship: "Fill/Ship",
    receive: "Receive",
    testing_samples: "Testing Samples",
    final_summary: "Final Summary",
    order_complete: "Order Complete",
    order_cancelled: "Order Cancelled",
    overview: "Overview",
    change_status: "Change status",
    trail: "Trail",
    kit_requested: "Kits Requested",
    within_valid_time: "Within Valid Timeframe",
    kit_name: "Kit Name",
    test_included: "Test Included",
    test: "Test",
    include: "Include?",
    sample: "Sample",
    included_for_collection: "Included For Collection",
    include_for_collection: "Include For Collection",
    sample_id_barcode: "Sample Id / Barcode",
    sample_recieved: "Sample Received",
    test_performed: "Test Performed",
    received: "Received?",
    collection_id_barcode: "Collection ID / Barcode",
    retest: "Retest?",
    lab_test_barcode: "Lab / Test Barcode",
    test_barcode: "Test Barcode",
    value: "Value",
    add_test: "Add Test",
    approve: "Approve",
    ship: "Ship",
    complete: "Complete",
    cancel: "Cancel",
    contact_form: "Contact Form",
    print_shipping_label: "Print Shipping Label",
    program_name_code: "Program Name (Code)",
    test_date_start: "Test Date Start",
    test_date_end: "Test Date End",
    send_to_preventx: "Send to Preventx",
    // Risk Assessment
    score: "Score",
    order: "Order",
    review_assessment: "Review Assessment",
    risk: "Risk",
    //Reports
    reports: "Reports",
    //Participant report
    participants_report: "Participants Report",
    order_report: "Order Report",
    client_navigation: "Client Navigation",
    BCHD_negative_report: "BCHD Negative Report",
    Navajo_Nation : "Navajo Nation",
    Southern_Tribal_Health_Board: "Southern Tribal Health Board",
    BCHD_positive_report: "BCHD Positive Report",
    risk_score: "Risk Score",
    shipment_start_date: "Shipment Date Start",
    shipment_end_date: "Shipment Date End",
    receipt_start_date: "Receipt Date Start",
    receipt_end_date: "Receipt Date End",
    affiliate_code: "Affiliate Code",
    birthday: "Birthday(Age)",
    latest_order_date: "Latest Order Date",
    latest_shipment_date: "Latest Shipment Date",
    latest_receipt_date: "Latest Receipt Date",
    latest_test_result: "Latest Test Result",
    birth_date_start: "Birth Date Start",
    birth_date_end: "Birth Date End",
    test_results: "Test Result",
    order_results: "Order Results Summary",
    order_samples: "Order Samples",
    lab: "Lab",
    case_code: "Case Code",
    auto_reorder: "Auto Reorder",
    positive_result: "Positive Result?",
    result_displayed: "Result Displayed",
    result_name_english: "Result Name (English)",
    result_name_spanish: "Result Name (Spanish)",
    result_description_english: "Result Description (English)",
    result_description_spanish: "Result Description (Spanish)",
    test_code: "Test Code",

    export: "Export",
    //Verify Test Results
    serial_number: "Serial Number",
    //Label Report
    label_type: "Label Type",
    label_size: "Label Size",
    total_sheets: "Total Sheets",
    //Program Codes
    program_codes: "Program Codes",
    program_code: "Program Code",
    zipcodes: "Zipcodes",
    add_to_region_lock: "Add To Specimen Availability",
    remove_from_region_lock: "Remove from Specimen Availability",
    region_lock: "Specimen Availability",
    duplicates: "Duplicate Labels",
    //Reminder Queue
    reminder_queues: "Reminder Queues",
    reminder_queue: "Reminder Queue",
    user_name: "User Name",
    reminder_type: "Reminder Type",
    sent_via: "Sent Via",
    sent_date: "Sent Date",
    retry_count: "Retry Count",
    reminder_history: "Reminder History",
    n_a: "N/A",
    none: "None",
    //Spanish Labels
    spanish_name: "Spanish Name",
    spanish_description: "Spanish Description",
    generate_report: "Generate Report",
    previous_status: "Previous Status",
    notice: "Notice",
    generate_labels: "Generate Labels",
    select_file: "Select File",
    sample_id: "Sample ID",
    important: "Important",
    yes: "Yes",
    no: "No",
    Yes: "Yes",
    No: "No",
    do_not_know: "I don’t know",
    clinic_address: "Clinic Address",
    clinic_phone: "Clinic Phone",
    order_sequence_number: "Order Sequence Number",
    change: "Change",
    email_verified: "Email verified",
    email_not_verified: "Email not verified",
    phone_verified: "Phone verified",
    phone_not_verified: "Phone not verified",
    date_received: "Date Received",
    date_tested: "Date Tested",
    positive: "POSITIVE",
    equivocal: "EQUIVOCAL",
    negative: "Negative",
    clinic_choice: "Clinic Choice",
    comments: "Comments",
    user_profile: "User Profile",
    go_to_home_page: "Go to home page",
    select_language: "Select Language",
    invalid: "Invalid",
    zero_one: "0-1",
    two_four: "2-4",
    five_nine: "5-9",
    ten_or_more: "10 or more",
    Always: "Always",
    Sometimes: "Sometimes",
    Never: "Never",
    change_email: "Change Email",
    change_phone: "Change Phone",
    very_high: "very high",
    high: "high",
    intermediate: "intermediate",
    low: "low",
    print_results_report: "Print Results Report",
    announcement: "Announcement",
    external_lab_key:"External Lab Key",

    of: "of",
    admin: "admin",
    superadmin: "superadmin",
    sponsor: "sponsor",
    orders_results: "Orders / Results",
    email_address: "Email Address",
    spanish_cost: "Spanish Cost",

    submitted_status: "Submitted",
    approved_status: "Approved",
    shipped_status: "Shipped",
    received_status: "Received",
    testing_status: "Testing",
    review_status: "Review",
    complete_status: "Complete",
    cancelled_status: "Cancelled",
    incomplete_status: "Incomplete",
    "sent to preventx_status": "Sent to preventx",

    start_date:"Start Date",
    end_date:"End Date",
    None: "None",
    Cancelled: "Cancelled",
    Pending: "Pending",
    continue: "Continue",
    eligibility_override: "Eligibility Override",

    // Master External Admin

    external_admin: "External Admin",
    externaladmin: "External Admin",
    // Extra
    // password_changed_successfully: "Password Changed Successfully"

    enter_zip_code_of_your_physical_home_adress: "Enter Zip Code of your Physical (Home) Address",
    enter_physical_home_address_line_1:"Physical (Home) Address Line 1",
    enter_physical_home_address_line_2:"Physical (Home) Address Line 2",
    would_you_like_test_hiv_at_home:"Would you like to order an at-home HIV test?",
    visit_native_test:"Visit Native Test",
    select_program_code:"Select Program code",
    program_code_report:"Program Code Report",
    navajo_zip_code: "Navajo Zip Code",

    external_lab: "External Lab",
    sample_type: "Sample Type",

    syphilis: "Syphilis",
    hepatits: "Hepatitis C",

    kit_type: "Kit Type",
    race_label: "We have updated the race values on our database.<br>Please select a new race from the listed below.",
    report_order: "Report Order",
    date_specimen_received: "Date Specimen Received", 
    date_test_completed: "Date Test Completed"
  },
  strings: {
    and:"and",
    // splash screen
    splash_page: "Welcome!",
    // login screen
    login_account: "Welcome! Please login to your account.",
    agreement: "By clicking Login, you agree to our",
    acknowledge: "and have read and acknowledge our",
    // program eligibility check
    program_eligibility_check: "Program Eligibility Check",
    program_eligibility_check_text:
      "Please enter following details to check your eligibility for the program.",
    program_code_valid_not_allowed_override: "Program code is valid. ",
    select_your_state: "Select your state",
    program_code_valid: " Program code is valid",
    program_code_invalid: " is not a valid program code.",
    please_validate_program_code: "Please validate program code",
    // register
    register_account: "Create a new account.",
    register_account_success: "User registered successfully.",
    select_your_city: "Select your city",
    select_your_county: "Select your county",
    select_your_home_county: "Select your home county",
    select_your_home_state:"Select your home state  ",
    // Risk Quiz
    quiz_account:
      "If you have ever engaged in sexual activity, the following questions will estimate your likelihood of exposure to a sexually transmitted infection (STI).",
    // Place Order
    place_order_text: "Please select your tests.",
    retesting: "Are you re-testing after treatment? ",
    used_in_past: "Have you used IWTK in the past?",
    first_sti_test: "Is this your first STI test?",
    client_navigator:
      "Do you want a health navigator to contact you about additional services and resources? Health navigators are members of our team who can answer questions about your test result, help you make appointments with a healthcare provider, and link you to prevention and treatment services.",
    clinic_info:
      "Choose a clinic/public health department that can assist you should you have a positive result. Some clinic centers have a fee, and this fee can be seen when selecting the clinic.",
    clinic_info_for_md:
      "Please select the clinic you may wish to visit in case of a positive result.  If you receive a positive test result, please contact a healthcare provider as soon as possible for treatment.  IWTK does not provide treatment or contact providers.",
    clinic_test_results:"If you receive a positive test result, please see a healthcare provider as soon as possible for treatment.  IWTK does not provide treatment.  You may print the Results Report or take a screenshot of your results to show your provider.",
      attestation:
      "I attest that I am requesting this kit on behalf of myself for my personal use. I also understand that by placing this order, I agree an IWTK team member may contact me via phone or email to gather feedback or share future opportunities.",
    select_symptoms:
      "Are you experiencing any of the following symptoms? Please select all that apply.",
    empty_symptoms:
      "No symptoms required for this sample.",
    be_sure_to_wait_3_months:
      "(Be sure to wait 3 months after completing your treatment before being retested.)",
    how_heard_field: "The how heard name field is required",
    the_alaska_IWTK_testing_service_is_made_possible:
      "The Alaska IWTK testing service is made possible by the Alaska Native Tribal Health Consortium (ANTHC). By submitting an order, you agree that all your test results (positive and negative) will be shared with ANTHC to ensure appropriate medical follow up. Should you have any questions or concerns please contact the Alaska IWTK team at IWantTheKitAlaska@anthc.org or call 877-334-8762.",
      sti_screening_kit_message_0:"By ordering the STI screening kit, you agree that your results, if positive, will be shared with the Tribal Epidemiology Center (TEC), Indian Health Service (IHS) Area Office, State Health Department, or other public health authority. Your results may also be shared with your treating provider. If you are a resident of Nebraska, you agree that your results, even if negative, may be reported to the Nebraska Department of Health and Human Services or your local public health authority, if required by law. You acknowledge that you have read the Johns Hopkins Notice of Privacy Practices and IWTK's privacy policy, both available in the footer of this website, and you understand how your information may be used and disclosed by Johns Hopkins.",
      sti_screening_kit_message_1:"By ordering the STI screening kit, you agree that your results, if positive, will be shared with the Tribal Epidemiology Center (TEC), Indian Health Service (IHS) Area Office, State Health Department, or other public health authority. Your results may also be shared with your treating provider. If you are a resident of Nebraska, you agree that your results, even if negative, may be reported to the Nebraska Department of Health and Human Services or your local public health authority, if required by law. You acknowledge that you have read the Johns Hopkins Notice of Privacy Practices and IWTK's privacy policy, both available in the footer of this website, and you understand how your information may be used and disclosed by Johns Hopkins.",
    sti_screening_kit_message_2:", both available in the footer of this website, and you understand how your information may be used and disclosed by Johns Hopkins.",
    in_order_to_assist_with_your_medical:
      "In order to assist with your medical care through the BCHD Sexual Health and Wellness Clinic, your name, date of birth, test order, and negative results will be shared with your provider.",
    check_this_box_if_you_do_NOT_want:
      "Check this box if you do NOT want negative results to be shared with BCHD. (Please Note - All positive results are reported to the health department to help you receive the best possible care. Reporting of some test results is mandated by law.)",
    // forgot password
    forgot_account:
      "Please enter your username (email address or mobile number) and we will send you a token to reset your password.",
    forgot_password_success:
      "Please check you email/SMS. You will receive a password recovery code at your email/phone in a few minutes.",
    // forgot password
    reset_account: "Please enter token sent to you on your email/phone.",
    reset_account_success:
      "Your password has been reset successfully. You can now login with your new password.",
    // verify email
    verification:
      "Please check the welcome email/SMS we sent you and enter the code in that email/SMS to verify your account. The username is either email address or phone.",
    verify_account_success: "User verified successfully.",
    // new password
    new_password: "You need to set new password for your account.",
    // HIV KIT once in 3 month
    hiv_kit_once_in_3_month:
      "HIV Kits can only be ordered once every 90 days.  Your last HIV Kit was ordered on",
    // Register Consent Message
    register_consent_message:
      "By registering for this program, I consent to receive notifications from IWTK regarding updates to my order and other general reminders.",
    // admin side
    when_you_are_done_looking_at_your_account:
      "When you are done looking at your account, please use the button at the top right corner of the screen and close your browser to completely log out of the system.",
    // login
    we_have_recenlty_move_to_new_system:
      "We have recently moved to a new system. If you already have an IWTK account and can’t login, you will need to use the ‘Forgot Password’ link below to setup a new password.",
    you_are_eligible_for_the_program_you_can_register_now:
      "You are eligible for the program. You can register now.",
    you_need_to_check_your_eligibility_before_registering:
      "You need to check your eligibility before registering.",
    // 404
    sorry_we_could_not_find_that_page: "Sorry we could not find that page :(",
    // Coming soon
    this_page_is_coming_soon: "This page is coming soon :)",
    // Participant
    select_one_status: "Select one status",
    results_are_uploaded_for: "Results are not uploaded for",
    you_are_not_eligible_for_the_program_as_you_are_not_atleast_14_years_old:
      "You are not eligible for the program as you are not at least 14 years old.",
    enter_email_and_confirm_email: "Please Enter email & Confirm email",
    your_email_and_confirm_email_do_not_match:
      "Your email and Confirm email do not match",
    enter_phone_and_confirm_phone: "Please Enter phone & Confirm phone",
    your_phone_and_confirm_phone_do_not_match:
      "Your phone and Confirm phone do not match",
    fill_the_risk_assessment_before_placing_order:
      "Fill the risk assessment before placing order.",
    complete_your_first_order: "Complete your first order.",
    you_have_a: "You have a ",
    risk_of_STIs: " risk of STIs",
    //Questions
    are_you_25_years_old_or_younger: "Are you 25 years old or younger?",
    have_you_had_either_a_new_sex_partner_or_multiple_partners_in_the_last_90_days:
      "Have you had either (or both) a new sex partner or multiple partners in the last 90 days?",
    right_now_do_you_have_more_than_one_sex_partner:
      "Right now do you have more than one sex partner?",
    have_you_ever_been_told_you_had_a_sexually_transmitted_infection_or_have_you_ever_been_treated_for_a_sexually_transmitted_infection:
      "Have you ever been told you had a sexually transmitted infection or have you ever been treated for a sexually transmitted infection?",
    how_many_sex_partners_have_you_had_in_the_last_90_days:
      "How many sex partners have you had in the last 90 days?",
    when_you_have_sex_do_you_use_a_condom:
      "When you have sex do you use a condom?",
    are_you_sure_you_want_to_logout: "Are you sure you want to logout?",
    press_enter_to_select: "Press enter to select",
    press_enter_to_remove: "Press enter to remove",
    // Program code
    program_code_info:
      "Have you been given a program code? If not, please skip this field.",
    invalid_state_or_zipcode:"Invalid state or zipcode",
    Baltimore_City_Health_Department_Sexual_Health_and_Wellness_Clinic_East:"Baltimore City Health Department - Sexual Health and Wellness Clinic East" ,
    Baltimore_City_Health_Department_Sexual_Health_and_Wellness_Clinic_West:"Baltimore City Health Department - Sexual Health and Wellness Clinic West",
    new_order_message:"If you need to update your mailing address on file, please do so by accessing the profile section in your IWTK account.",

    //Cancel Order Statuses
    ship_to_address_are_incorrect_or_incomplete:"one or more details in the ship to address are incorrect or incomplete. Please review and reorder with updated address information",
    canceled_ordered_penile_and_vaginal_swab:"you ordered a penile and vaginal swab. IWTK allows clients to order only one genital swab. Please reorder and select the genital swab appropriate for you",
    incomplete_or_invalid_name:"incomplete or invalid name",
    Undelivered_kit:"undelivered kit was returned by the postal service. Please check your address and reorder",
    Contact_returned:"contact form was not returned",
    Swab_condition_testing:"swab condition is unacceptable for testing",
    Swab_returned:"swab was not returned",
    Kit_expired:"kit expired before the collection date",
    other:"other",

    cancellation_reason: "Cancellation Reason",
    select_cancel_reason: "Select Cancel Reason",
    return_to_order: "Return to Order",
    select_cancellation_reason: "Please select a valid cancellation reason",
    select_how_heard_least_3: "Please select at least one choice. You may select up to 3 choices.",
    max_how_heard:"Maximum of 3 options selected. First remove a selected option to select another.",

    //Syphilis
    positive_syphilis: "Have you had a positive syphilis test in the past?",
    treated_syphilis: "Have you ever been treated for syphilis? Usually, treatment is a shot in the butt.",
    exposed_syphilis: "Are you worried you may recently have been exposed to syphilis?",
    pregnat_syphilis: "Are you pregnant or do you think you could be pregnant?",
    one_ans: "Please choose one answer.",

    //hepatitis c
    positive_hepatitis: "Have you had a positive Hepatitis C test in the past?",
    treated_hepatitis: "Have you ever been treated for Hepatitis C?",
    symptoms_selection_text : "Are you experiencing any of the following symptoms? Please select all that apply.",
    syphilis_selection_text : "Your answers to the questions about Syphilis will help your healthcare providers if your test is positive.",
    hepatits_selection_text: "Your answers to the question(s) about Hepatitis C will help your healthcare providers if your test is positive.",
    region_lock_text: "Choose the locations where this specimen is available."
  },
  validations: {
    either_phone_or_email_is_required: "Either phone or email is required.",
    enter_email: "Please enter email",
    enter_confirm_email: "Please enter confirm email",
    enter_confirm_phone: "Please enter confirm phone",
    enter_phone: "Please enter phone number",
    enter_valid_email: "Please enter valid email",
    enter_password: "Please enter password",
    enter_token: "Please enter token",
    enter_old_password: "Current password is not correct",
    enter_new_password: "Please enter new password",
    enter_confirm_password: "Please enter confirm password",
    password_validation: "The password must be at least 8 characters",
    confirm_password_validation:
      "Your password and confirmation password do not match.",
    confirm_email_validation: "Your email and confirmation email do not match.",
    enter_name: "Please enter name",
    confirm_phone_validation: "Your phone and confirmation phone do not match.",
    enter_description: "Please enter description",
    select_test_kit: "Please select test kit",
    select_how_heard: "Please select how heard",
    select_test_types: "Please select test types",
    enter_user_name: "Please enter username",
    enter_birth_date: "Please enter birth date",
    enter_zip_code: "Please enter zip code",
    select_state: "Please select state",
    enter_first_name: "Please enter first name",
    enter_last_name: "Please enter last name",
    enter_address: "Please enter address",
    enter_address_1: "Please enter address 1",
    select_gender: "Please select gender identity",
    select_sex_with: "Please select Who do you have sex with",
    please_select_all_that_apply: "Please select all that apply",
    select_race: "Please select race",
    race: "Race field is required",
    hispanic: "Hispanic field is required ",
    gender: "Gender is required gender",
    select_county: "Please select county",
    select_city: "Please select city",
    select_test_kits: "Please select test kits",
    select_clinic: "Please select clinic",
    attestation: "Attestation is required",
    enter_current_password: "Please enter current password",
    phone_validation: "The phone number may not be greater than 15 characters",
    phone_min_validation: "The phone number must be at least 11 characters",
    phone_regex: "The phone number must be in valid format",
    select_preferred_contact_method: "Please select preferred contact method",
    select_language_preference: "Please select language preference",
    select_hispanic: "Please select hispanic",
    select_roles: "Please select roles",
    select_permissions: "Please select permissions",
    select_disease: "Please select diseases",
    select_assay_types: "Please select assay types",
    select_specimen_types: "Please select specimen type",
    select_symtoms: "Please select symptoms",
    enter_cost: "Please enter cost",
    enter_city: "Please enter city",
    enter_code: "Please enter code",
    username_email_mobile: "Please enter username (email or mobile number)",
    question_1: "The question 1 field is required",
    question_2: "The question 2 field is required",
    question_3: "The question 3 field is required",
    question_4: "The question 4 field is required",
    question_5: "The question 5 field is required",
    question_6: "The question 6 field is required",

    enter_mailing_address_1:"Please enter mailing address 1",
    enter_mailing_address_2:"Please enter mailing address 2",
    enter_mailing_city:"Please enter mailing city",
    enter_mailing_state:"Please enter mailing state",
    enter_mailing_county:"Please enter mailing county",
    enter_mailing_zipcode:"Please enter mailing zipcode",
    select_sex_at_birth:"Please Select Sex Assigned at Birth",
    program_code:"Please Select Program Code",

    test_result:"Please select a test result",
    enter_end_date:"Please enter end date",
    enter_start_date:"Please enter start date",

    result_name_english: "Please select result name",
    test_code: "Please enter test code",
    case_code: "Please enter case code",
    select_lab: "Please select lab",
  }
};
